// Copyright (c) 2016 Deere & Company

import AttachmentClaim from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.claims.attachment,
    partsGroupedByPartNumber: state.claims.partsGroupedByPartNumber
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AttachmentClaim);



// WEBPACK FOOTER //
// ./src/claim/attachment/state-connector.js